import { render, staticRenderFns } from "./EmarPatientDispenseReportV1.vue?vue&type=template&id=35d5216a&scoped=true&"
import script from "./EmarPatientDispenseReportV1.vue?vue&type=script&lang=js&"
export * from "./EmarPatientDispenseReportV1.vue?vue&type=script&lang=js&"
import style0 from "./EmarPatientDispenseReportV1.vue?vue&type=style&index=0&id=35d5216a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d5216a",
  null
  
)

export default component.exports